import gsap from 'gsap'
import { lenis } from './lenis'
import { checkForSubmenu } from './utilities'

export class Navigation {
  constructor(el) {
    this.open = false
    this.nav = el
    this.items = this.nav.querySelectorAll('.menu-item')
    this.currentHeaderTheme
    this.mainItems = this.nav.querySelectorAll('.navigation__main .menu-item a:not(.sub-menu a)')
    this.triggers = document.querySelectorAll('[data-open-nav]')

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        if (!this.open) {
          this.openNavigation()
        } else {
          this.closeNavigation()
        }
      })
    })

    this.items.forEach((item) => {
      checkForSubmenu(item)
    })

    this.mainItems.forEach((item) => {
      if (window.matchMedia('(pointer: fine)').matches) {
        item.parentElement.addEventListener('mouseenter', () => this.itemHover(item))
        item.parentElement.addEventListener('mouseleave', () => this.itemUnhover(item))
      }
    })

    this.itemsWithMenu = this.nav.querySelectorAll('.has-sub-menu')

    this.itemsWithMenu.forEach((item) => {
      const link = item.querySelector('a')
      link.addEventListener('click', this.toggleSubmenu.bind(this))
    })

    this.setActiveState()
  }
  setActiveState() {
    const url = window.location.href
    const menuItems = document.querySelectorAll('.header__nav .menu-item a, .navigation__main .menu-item a')

    menuItems.forEach((item) => {
      item.parentElement.classList.remove('current-page')
      if (item.href == url) {
        item.parentElement.classList.add('current-page')
      }
    })
  }
  openNavigation() {
    this.open = true
    this.nav.style.opacity = 1
    this.nav.style.zIndex = 97

    lenis.stop()

    const header = document.querySelector('.header')
    const headerMenuItems = document.querySelectorAll('.header__menu .menu-item')
    const dividersHorizontal = this.nav.querySelectorAll('.divider--1, .divider--2, .divider--4')
    const dividersVertical = this.nav.querySelectorAll('.divider--3')
    const timeline = gsap
      .timeline({})
      .to(
        this.nav,
        {
          duration: 1.25,
          clipPath: 'inset(0 0 0% 0)',
          ease: 'expo.inOut'
        },
        '<'
      )
      .to(
        headerMenuItems,
        {
          y: window.innerWidth < 1024 ? '-5.405vw' : '-2.604vw',
          duration: 0.6,
          stagger: 0.08
        },
        '<'
      )
      .from(
        dividersHorizontal,
        {
          duration: 1,
          width: 0,
          ease: 'power3.inOut',
          clearProps: 'all'
        },
        '-=0.9'
      )
      .from(
        dividersVertical,
        {
          duration: 1,
          height: 0,
          ease: 'power3.inOut',
          clearProps: 'all'
        },
        '<'
      )

    this.currentHeaderTheme = header.dataset.theme

    header.dataset.theme = 'white'
    document.body.setAttribute('data-navigation-status', 'open')
  }
  closeNavigation() {
    this.open = false

    lenis.start()
    const header = document.querySelector('.header')
    const headerMenuItems = document.querySelectorAll('.header__menu .menu-item')
    const timeline = gsap
      .timeline({
        onComplete: () => {
          this.nav.style.opacity = 0
          this.nav.style.zIndex = -1
        }
      })
      .to(this.nav, {
        duration: 1,
        clipPath: 'inset(0 0 100% 0)',
        ease: 'expo.inOut'
      })
      .to(
        headerMenuItems,
        {
          y: 0,
          duration: 0.6,
          stagger: 0.08
        },
        '-=0.5'
      )

    header.dataset.theme = this.currentHeaderTheme
    document.body.setAttribute('data-navigation-status', 'closed')
  }
  snapCloseNavigation() {
    this.open = false
    const headerMenuItems = document.querySelectorAll('.header__menu .menu-item')
    document.body.setAttribute('data-navigation-status', 'closed')

    const timeline = gsap.timeline({}).to(this.nav, {
      duration: 0.01,
      clipPath: 'inset(0 0 100% 0)',
      ease: 'expo.inOut'
    }).to(
      headerMenuItems,
      {
        y: 0,
        duration: 0.6,
        stagger: 0.08
      },
      '+=0.6'
    )
  }
  toggleSubmenu(item) {
    const menuItem = item.currentTarget.parentNode
    const subMenu = menuItem.querySelector('.sub-menu')

    if (subMenu.classList.contains('sub-menu-open')) {
      gsap.to(subMenu, {
        duration: 0.5,
        height: 0,
        ease: 'power1.inOut'
      })

      item.currentTarget.classList.remove('sub-menu-open')
      subMenu.classList.remove('sub-menu-open')
    } else {
      gsap.to(subMenu, {
        duration: 0.5,
        height: 'auto',
        ease: 'power1.inOut'
      })

      item.currentTarget.classList.add('sub-menu-open')
      subMenu.classList.add('sub-menu-open')
    }
  }
  itemHover(item) {
    const chars = item.querySelectorAll('.char')

    gsap.to(chars, {
      duration: 0.2,
      stagger: 0.02,
      scale: 1.15,
      fontFamily: 'Times Now',
      fontStyle: 'italic',
      color: '#FFB9D8'
    })

    gsap.to(item, {
      duration: 0.2,
      letterSpacing: 2
    })
  }
  itemUnhover(item) {
    const chars = item.querySelectorAll('.char')

    gsap.to(chars, {
      duration: 0.2,
      stagger: 0.02,
      scale: 1,
      fontFamily: 'Suisse Intl',
      fontStyle: 'normal',
      color: '#FFFFFF'
    })
  }
}

export default () => {}
